import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Container, Typography, Box, Paper } from '@mui/material';
import { useTranslation } from 'react-i18next';
import CloseButton from '../CloseButton/CloseButton';

const HeaderContainer = ({ children }) => (
  <Box display="flex" justifyContent="flex-start" alignItems="flex-start" mb={2} sx={{ gap: 2 }}>
    {children}
  </Box>
);

const HeaderTitle = (props) => (
  <Typography
    {...props}
    sx={{
      fontWeight: 500,
      flex: '1 1 auto',
      minWidth: 0,
      wordBreak: 'break-word',
      overflowWrap: 'break-word',
      whiteSpace: 'normal'
    }}
  />
);

function AboutUs() {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <Container maxWidth="md" sx={{ py: 4 }}>
      <Paper elevation={2} sx={{ p: 4, position: 'relative' }}>
        <HeaderContainer>
          <HeaderTitle variant="h3" component="h1">
            {t('aboutUsTitle')}
          </HeaderTitle>
          <CloseButton
            onClick={() => navigate('/')}
            size="small"
            color="primary"
            sx={{ position: 'absolute', top: 8, right: 8, zIndex: 2 }}
          />
        </HeaderContainer>
        
        <Box sx={{ mt: 3 }}>
          <Typography variant="h5" component="h2" gutterBottom>
            {t('ourMissionTitle')}
          </Typography>
          <Typography variant="body1" paragraph>
            {t('ourMissionText')}
          </Typography>
        </Box>

        <Box sx={{ mt: 3 }}>
          <Typography variant="h5" component="h2" gutterBottom>
            {t('whyStandStrongTitle')}
          </Typography>
          <Typography variant="body1" paragraph>
            {t('whyStandStrongText')}
          </Typography>
        </Box>

        <Box sx={{ mt: 3 }}>
          <Typography variant="h5" component="h2" gutterBottom>
            {t('howItWorksTitle')}
          </Typography>
          <Typography variant="body1" paragraph>
            {t('howItWorksText')}
          </Typography>
        </Box>

        <Box sx={{ mt: 3 }}>
          <Typography variant="h5" component="h2" gutterBottom>
            {t('ourCommitmentTitle')}
          </Typography>
          <Typography variant="body1" paragraph>
            {t('ourCommitmentText')}
          </Typography>
        </Box>

        <Box sx={{ mt: 4, p: 2, bgcolor: 'primary.light', color: 'primary.contrastText', borderRadius: 1 }}>
          <Typography variant="body2" align="center">
            {t('aboutContact')}
          </Typography>
        </Box>
      </Paper>
    </Container>
  );
}

export default AboutUs;
